// extracted by mini-css-extract-plugin
export default {"container":"Tags_container__Lxkjw","addTags":"Tags_addTags__Nia+f"};